import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { cartSelector, removeItem, increaseQuantity, decreaseQuantity, removeGiftCard } from 'slices/cart';
import { userSelector } from 'slices/user';
// images
import preview from 'assets/img/preview.jpg';
import giftImageCard from 'assets/img/giftCard.jpg';
// icons
import { BiCheck, BiMinus } from 'react-icons/bi';
import { BsPlus, BsArrowsFullscreen } from 'react-icons/bs';
//api
import { addItemCart, decreaseQuantityItemCart, removeItemCart, deleteGiftCardCart } from 'api/ecommerce';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//helpers
import { detailTypeProductRedirect } from 'helpers';
import { formatCurrency } from 'utils/currencyFormatter';
//components
import Image from 'components/image';
import WatchModalUser from "components/userzone/modal";
import './cart.scss';

const Items = (props) => {
  const { assignedLibrary} = useAssignedLibrary();

  const { items, hasGiftCard, giftCard } = useSelector(cartSelector);

  const dispatch = useDispatch();

  const [modalShow, setModalShow] = useState(false);
  const [item, setItem] = useState('');

  const { isLogged } = useSelector(userSelector);

  const { t } = useTranslation(['cart']);

  const increaseQuantityItem = async (id) => {
    if (isLogged) {
      const payload = { item: id, quantity: 1 };
      const { status } = await addItemCart(payload);
      if (status === 201) {
        dispatch(increaseQuantity(id));
      } else {
        console.log('error');
      }
    } else {
      dispatch(increaseQuantity(id));
    }
  };

  const decreaseQuantityItem = async (id) => {
    if (isLogged) {
      const payload = { item: id, quantity: 1 };
      const { status } = await decreaseQuantityItemCart(payload);
      if (status === 200) {
        dispatch(decreaseQuantity(id));
      } else {
        console.log('error');
      }
    } else {
      dispatch(decreaseQuantity(id));
    }
  };

  const removeProductCart = async (item) => {
    if (isLogged) {
      const payload = { item: item.id };
      const { status } = await removeItemCart(payload);
      if (status === 200) {
        dispatch(removeItem(item));
      } else {
        console.log('error');
      }
    } else {
      dispatch(removeItem(item));
    }
  };

  const removeGiftCardCart = async () => {
    dispatch(removeGiftCard());
    if (isLogged) {
      const payload = { item: giftCard };
      const { status } = await deleteGiftCardCart(payload);
      if (status === 200) {
      } else {
        console.log('error');
      }
    } else {
      dispatch(removeGiftCard());
    }
  };

  const handleFullScreen = (img) => {
    setItem(img)
    setModalShow(true)
  }

  return (
    <Row>
      <Col md={12}>
        {items?.map((item, i) => (
          <div key={i} className="cart-item">
            <Col sm={10} md={10} className="cart-item__details position-relative">
              <React.Fragment className="position-relative">
                {item.image && <BsArrowsFullscreen className="icon-md position-absolute p-1 icon-fullscreen" onClick={() => handleFullScreen(item.image)} />}
                <Link className="cursor-pointer py-0" to={detailTypeProductRedirect(item,assignedLibrary)}>
                  <Image key={item.id} src={item.image} fallbackSrc={preview} height="100" />
                </Link>
              </React.Fragment>
              <Col sm={12} md={12}>
                <Link
                  to={detailTypeProductRedirect(item,assignedLibrary)}
                  className=" cart-item__link-title"
                >
                  <h2 title={item.title}> {item.title} </h2>
                </Link>
                {item.authors && (
                  <Col sm={6} md={12} className="position-element">
                    <p className="mr-5 container-authors__paragrap">
                      {item.authors.length > 0 ? item.authors[0].nombre_autor : ''}
                    </p>
                  </Col>
                )}
                <Col sm={3} md={12} className="position-element">
                  <BiCheck className="icon-check"/> {t('available')}
                </Col>
              </Col>
            </Col>
            {props?.isResume ? (
              <Col sm={2} md={2} className="cart-item__resume position-relative">
                <div className="infoQuantyItem">
                  <div className="dataItem">
                    <div className="fieldData">{`${t('quantity')}:`}</div>
                    <div className="valueData">{item.quantity}</div>
                  </div>
                </div>
                <div className="infoItem">
                  <div className="dataItem">
                    <div className="fieldData">{`${t('price')}:`}</div>
                    <div className="valueData">{formatCurrency(item.price)}</div>
                  </div>
                  <div className="dataItem">
                    <div className="fieldData">{`${t('total')}:`}</div>
                    <div className="valueData">{formatCurrency(Number(item.quantity) * Number(item.precio_venta_publico) || 0)}</div>
                  </div>
                </div>
              </Col>
            ) : (
              <Col sm={2} md={2} className="cart-item__actions">
                <Col lg={12} className="d-flex flex-column justify-content-between h-100 m-0 py-0 container-add-remove">
                  <h6 className='m-0 cart-price'>
                    <strong>{formatCurrency(item.price)}</strong>
                  </h6>
                  <Col lg={12} className="add-remove pr-3">
                    <p className="m-1">
                      <Link
                        to={`/${assignedLibrary}/carrito`}
                        onClick={() => decreaseQuantityItem(item.id)}
                        aria-label={t('addproduct')}
                        className="pr-2"
                      >
                        <BiMinus className="icon-md" color="#3a86ff" />
                      </Link>
                    </p>
                    <Button className="p-0 m-0">{item.quantity}</Button>
                    <p className="m-1">
                      <Link
                        to={`/${assignedLibrary}/carrito`}
                        onClick={() => increaseQuantityItem(item.id)}
                        aria-label={t('removeunitproduct')}
                        className="pr-2"
                      >
                        <BsPlus className="icon-md" color="#3a86ff" />
                      </Link>
                    </p>
                  </Col>{' '}
                  <Link
                    to={`/${assignedLibrary}/carrito`}
                    className="cart-item__delete"
                    aria-label={t('removeproduct')}
                    onClick={() => removeProductCart(item)}
                  >
                    <Button className="white-btn p-1">{t('remove').toUpperCase()}</Button>
                  </Link>
                </Col>
              </Col>
            )}
          </div>
        ))}
      </Col>
      <Col md={12}>
        {hasGiftCard && (
          <div className="cart-item">
            <div className="cart-item__details">
              <Image src={giftImageCard} className="style-giftcard" />
              <div className="d-flex flex-column">
                <h2>{t('giftcard')}</h2>
                <p className="mr-5 mt-5 style-paragraph">
                  {t('couponname')}
                </p>
                <h3 className="mt-1">
                  {giftCard?.title}
                </h3>
              </div>
            </div>
            <div className="cart-item__price">
              <div className="cart-item__price-value">
                <strong>{formatCurrency(giftCard?.discount_amount)}</strong>
              </div>
              <p
                className="mr-5 mt-5 style-paragraph"
              >
                {t('discountprice')}
              </p>
              <Button className="white-btn p-1 style-button-delete" onClick={() => removeGiftCardCart()}>
                {t('remove').toUpperCase()}
              </Button>
            </div>
          </div>
        )}
      </Col>
      <WatchModalUser
        item={item}
        show={modalShow}
        setShow={setModalShow}
      />
    </Row>
  );
};

export default Items;
